<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список населенных пунктов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать населенный пункт</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="mb-3">
            <label for="playlist-name" class="form-label">
                Название населенного пункта
            </label>
            <input type="text" class="form-control" id="playlist-name" v-model="formData.name" placeholder="Название">
        </div>

        <div class="mb-4">
            <div class="form-label">Регион</div>
            <v-select class="select"
                v-model="formData.region"
                :items="regions"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="update"/>
            <a class="btn btn-lg btn-grey btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import City from "../../../../models/City";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "CityEditComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_create: String,
        route_regions: String,
        route_update: String,
        route_get: String,
        city_id: {
            type: [Number, String],
        }
    },
    data: function () {
            return {
                city: new City({
                    route_update: this.route_update,
                    route_get: this.route_get
                }),
                regions: [],
                formData: {
                    name: '',
                    region: null
                },
            }
        },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        itemGet: async function () {
            let item = await this.city.get(this.city_id);
            this.formData.name = item.name;
            this.formData.region = item.region_id;
        },
        update: async function () {
            if (this.formData.name === '' || this.formData.name === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название населенного пункта!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.region === '' || this.formData.region === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите регион!' });
                this.toggleLoading();
                return;
            }

            let result = this.city.update({
                name: this.formData.name,
                region: this.formData.region
            }, this.city_id);
            if(result) {
                window.location.href = this.route_back;
            }
            else {
                console.log('error: create_brand');
            }
        },
        getRegions: async function () {
            let response = await axios.get(this.route_regions, {params: {
                    page: 1,
                    limit: 50,
                }}).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список регионов, что-то пошло не так' });
                this.toggleLoading();
            });

            this.regions = response.data.items;
        },
        showError() {
            this.$refs.Error.showError()
        }
    },
    mounted() {
        this.itemGet();
        this.getRegions();
    }
}
</script>

<style scoped>

</style>
